// Intervention et Projet partagent le même moteur de réalisation.
// Cette route conserve la distinction métier dans la navigation, mais réutilise
// volontairement l'écran Projet au lieu de maintenir un second écran fonctionnel.
import ProjectPage from '../../projects/ProjectPage/ProjectPage';

export default function InterventionDetailPage() {
  return <ProjectPage forcedRealizationType="intervention" />;
}
